import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryAddCargoEnterChangeRideEvent } from "../../../../common/types/order-details-history-change-ride-event";

type OrderDetailsHistoryEntryChangeRideContentAddCargoEnterProps = {
  event: OrderDetailsHistoryEntryAddCargoEnterChangeRideEvent;
};

const OrderDetailsHistoryEntryChangeRideContentAddCargoEnterComponent: FC<
  OrderDetailsHistoryEntryChangeRideContentAddCargoEnterProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .addCargoEnter;

  return (
    <div className="order_details_history_entry_list_item_content__section">
      <div className="order_details_history_entry_list_item_content__label">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryChangeRideContentAddCargoEnterComponent;
